import { render, staticRenderFns } from "./FlagshipGoalsWizardCustomizeGoal.vue?vue&type=template&id=9bb9bdba&scoped=true&"
import script from "./FlagshipGoalsWizardCustomizeGoal.vue?vue&type=script&lang=ts&"
export * from "./FlagshipGoalsWizardCustomizeGoal.vue?vue&type=script&lang=ts&"
import style0 from "./FlagshipGoalsWizardCustomizeGoal.vue?vue&type=style&index=0&id=9bb9bdba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb9bdba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VContainer,VForm,VIcon,VRow,VSlider,VTextField})
